import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const COLORS = ['#CE8FFB', '#7077FE', '#4CAF50', '#FF9800', '#F44336', '#2196F3'];

const AverageHoursChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="chart-loading">
        <p>Loading hours data...</p>
      </div>
    );
  }

  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="no-data-message">
        <p>No hours data available. Submit daily scans to see time allocation.</p>
      </div>
    );
  }

  // Transform object data to array for bar chart
  const chartData = Object.entries(data).map(([name, value]) => ({
    name,
    hours: value
  })).filter(item => item.hours > 0);

  if (chartData.length === 0) {
    return (
      <div className="no-data-message">
        <p>No time logged yet. Submit daily scans with hours to see distribution.</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis 
          dataKey="name"
          angle={-45}
          textAnchor="end"
          height={100}
          tick={{ fontSize: 12 }}
        />
        <YAxis 
          label={{ value: 'Hours', angle: -90, position: 'insideLeft' }}
          tick={{ fontSize: 12 }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '12px',
          }}
          formatter={(value) => [`${value} hrs`, 'Average']}
        />
        <Bar 
          dataKey="hours" 
          radius={[8, 8, 0, 0]}
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AverageHoursChart;
